<template>
  <div>
      <v-row align="center" justify="center" no-gutters>
        <v-col>
        <v-simple-table dense class="simple-table">
          <template v-slot:default>
            <thead>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in value"
                :key="item.name"
              >
                <td width="10px">{{ index + 1 }}.</td>
                <td>
                  <router-link :to="{ name: 'task_view', params: { id: item.id }}">{{ item.name }}</router-link>
                  <span class="ml-1" :class="['closed', 'completed'].includes(item.status) ? 'green--text' : 'red--text'">({{ item.status_ru }})</span>
                </td>

              </tr>
            </tbody>
          </template>
        </v-simple-table>
       </v-col>

        <v-col cols="1">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on"><v-icon @click="add" class="ml-3 pointer">mdi-plus-circle</v-icon></span>
            </template>
            <span>Добавить подзадачу</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-dialog persistent v-model="form.opened" max-width="600px">
        <v-card light>
          <v-card-title class="headline white--text" :class="form.color">{{ form.title }}
            <v-spacer></v-spacer>
            <a class="close" @click="cancel">×</a>
          </v-card-title>
          <v-card-text class="title pb-0 mt-8">
             <v-text-field
               dense
               name="name"
               v-model="form.item.title"
               class="shrink v-text-field-nodes required"
               label="Название"
               required
             />

             <div>
               <Redactor v-model="form.item.text" :url="urlObj" :id="id" :view="view"></Redactor>
             </div>

             <v-autocomplete
               hide-details
               :items="items.users|byDivision"
               v-model="form.item.responsible"
               label="Постановщик"
               item-value="id"
               item-text="name"
               autocomplete
               clearable
               class="required"
               :return-object="true"
               no-data-text="Нет результатов"
             >
               <template v-slot:item="data">
                   <v-list-item-avatar>
                     <img :src="data.item.tiny_pic ? data.item.tiny_pic.url : '/img/none.png'" />
                   </v-list-item-avatar>
                   <v-list-item-content>
                     <v-list-item-title v-html="data.item.name"></v-list-item-title>
                   </v-list-item-content>
               </template>
             </v-autocomplete>

             <v-autocomplete
               hide-details
               :items="items.users|byDivision"
               v-model="form.item.assigned"
               label="Исполнитель"
               item-value="id"
               item-text="name"
               autocomplete
               class="required"
               :return-object="true"
               no-data-text="Нет результатов"
             >
               <template v-slot:item="data">
                   <v-list-item-avatar>
                     <img :src="data.item.tiny_pic ? data.item.tiny_pic.url : '/img/none.png'" />
                   </v-list-item-avatar>
                   <v-list-item-content>
                     <v-list-item-title v-html="data.item.name"></v-list-item-title>
                   </v-list-item-content>
               </template>
             </v-autocomplete>

             <Date
               v-model="form.item.date_end"
               class="mt-6"
               label="Выполнить к"
               :required="true"
               :clearable="true"
               :right="130"
             />

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid" :class="form.color" :loading="form.pendingSave" @click="save">
              <v-icon small class="mr-2">mdi-content-save</v-icon>
              {{ $t('buttons.save')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { getAll, get, edit, save, remove } from '@/api'
import Date from '@/components/Date'
import Redactor from '@/components/redactor/Redactor'
import RefMixin from '@/views/Ref.vue'

export default {
  components: {
    Redactor,
    Date,
  },
  mixins: [RefMixin],
  props: {
    id: {
      type: Number
    },
    value: {
      default: function () {
        return []
      },
      type: [Array]
    },
    view: {
      type: String,
      default: 'view'
    },
  },
  data: function () {
    return {
      urlObj: 'task/',
      urlList: 'tasks/',

      items: {
        users: [],
      },
      refs: [
        { url: 'users/?is_active=true&fields[]=name&fields[]=tiny_pic&fields[]=userinfo__division__name&sort_by=last_name', name: 'users' },
      ],

      form: {
        opened: false,
        pendingSave: false,
        title: 'Добавить подзадачу',
        color: 'primary',
        item: {
          title: '',
          date_end: null,
          assigned: null,
          responsible: null
        },
      },
    }
  },
  computed: {
    valid () {
      if (this.form.item.title && this.form.item.date_end && this.form.item.assigned && this.form.item.responsible) { return true }
      return false
    }
  },
  methods: {
    add () {
      this.form.opened = true
    },
    cancel () {
      this.form.opened = false
      this.clear()
    },
    clear () {
      this.form.item = {
        title: '',
        date_end: '',
        assigned: null,
        responsible: null
      }
    },
    save () {
      this.form.opened = false
      this.form.item.parent = { id: this.id }
      this.form.item.is_template = false

      this.pendingSave = true
      this.$store.commit('SET_LOADING', true)

      save(this.urlList, this.form.item).then((response) => {
        this.value.push(response.data)
        this.pendingSave = false
        this.$store.commit('SET_LOADING', false)
        this.$notify({ group: 'main', title: 'Сохранить', text: 'Успешно!', type: 'success' })
      }).catch((err) => {
        this.pendingSave = false
        this.$notify({ group: 'main', title: 'Сохранить', text: `Ошибка! ${err.response.data.non_field_errors}`, type: 'error' })
        this.$store.commit('SET_LOADING', false)
      })
      this.clear()
    },
  }
}
</script>
<style>
.simple-table td {
  font-size: 16px !important;
  background-color: #F5F5F5 !important;
}
</style>
